import { Routes } from "../routes/Routes";

const useLogin = (authSelector, isActive) => {
  return Routes(authSelector, isActive);
};

export default useLogin;
